import { CthGame } from '@/screens/completeTheHand/CthGame'

export default function () {
  return <CthGame />
}
